import { Product } from 'pages/apps/Ecommerce/types';
import { ProductActionTypes } from './constants';

const INIT_STATE = {
    results: [],
    createdProduct: {},
    isProductCreated: false,
    loading: false,
    error: null,
    uploadedImage: null,
    productDetailsById: null,
    importLoading: false,
    importSuccess: false,
    importErrors: [] as string[],
    importProgress: 0,
    totalResults: 0,
    totalPages: 0,
    currentPage: 1,
};

type ProductActionType = {
    type:
        | ProductActionTypes.API_RESPONSE_SUCCESS
        | ProductActionTypes.API_RESPONSE_ERROR
        | ProductActionTypes.GET_PRODUCTS
        | ProductActionTypes.ADD_PRODUCT
        | ProductActionTypes.UPLOAD_IMAGE
        | ProductActionTypes.GET_PRODUCT_DETAILS
        | ProductActionTypes.DELETE_PRODUCT
        | ProductActionTypes.UPDATE_PRODUCT
        | ProductActionTypes.BULK_IMPORT_PRODUCTS
        | ProductActionTypes.RESET_IMPORT_STATE
        | '@@product/BULK_IMPORT_PROGRESS';
    payload: {
        actionType?: string;
        data?: Product[] | Product | any;
        error?: string | string[];
        uploadedUrl?: string;
        progress?: number;
    };
};

type State = {
    results: Product[];
    createdProduct: Product | {};
    isProductCreated: boolean;
    loading: boolean;
    error: string | null;
    uploadedImage: string | null;
    productDetailsById: Product | null;
    importLoading: boolean;
    importSuccess: boolean;
    importErrors: string[];
    importProgress: number;
    totalResults: number;
    totalPages: number;
    currentPage: number;
};

const Products = (state: State = INIT_STATE, action: ProductActionType): State => {
    const { type, payload } = action;

    switch (type) {
        case ProductActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = payload;
            switch (actionType) {
                case ProductActionTypes.GET_PRODUCTS:
                    return {
                        ...state,
                        results: Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []),
                        totalResults: data?.totalResults ?? state.totalResults,
                        totalPages: data?.totalPages ?? state.totalPages,
                        currentPage: data?.currentPage ?? state.currentPage,
                        loading: false,
                        error: null,
                    };
                case ProductActionTypes.ADD_PRODUCT:
                    return {
                        ...state,
                        createdProduct: data || {},
                        isProductCreated: true,
                        loading: false,
                        error: null,
                    };
                case ProductActionTypes.UPLOAD_IMAGE:
                    return {
                        ...state,
                        uploadedImage: payload.uploadedUrl || null,
                        loading: false,
                        error: null,
                    };
                case ProductActionTypes.GET_PRODUCT_DETAILS:
                    return {
                        ...state,
                        productDetailsById: data || null,
                        loading: false,
                        error: null,
                    };
                case ProductActionTypes.UPDATE_PRODUCT:
                    return {
                        
                        ...state,
                        results: Array.isArray(data) ? data : state.results,
                        loading: false,
                        error: null,
                    };
                case ProductActionTypes.DELETE_PRODUCT:
                    return {
                        ...state,
                        results: Array.isArray(data) ? data : state.results,
                        loading: false,
                        error: null,
                    };
                case ProductActionTypes.BULK_IMPORT_PRODUCTS:
                    return {
                        ...state,
                        importLoading: false,
                        importSuccess: true,
                        importProgress: 100,
                        importErrors: [],
                    };
                case '@@product/BULK_IMPORT_PROGRESS':
                    return {
                        ...state,
                        importProgress: payload.progress || 0,
                    };
                default:
                    return state;
            }
        }

        case ProductActionTypes.API_RESPONSE_ERROR: {
            const { actionType, error } = payload;
            switch (actionType) {
                case ProductActionTypes.GET_PRODUCTS:
                case ProductActionTypes.ADD_PRODUCT:
                case ProductActionTypes.UPLOAD_IMAGE:
                case ProductActionTypes.GET_PRODUCT_DETAILS:
                case ProductActionTypes.UPDATE_PRODUCT:
                case ProductActionTypes.DELETE_PRODUCT:
                    return {
                        ...state,
                        error: error as string || 'An error occurred',
                        loading: false,
                    };
                case ProductActionTypes.BULK_IMPORT_PRODUCTS:
                    return {
                        ...state,
                        importLoading: false,
                        importSuccess: false,
                        importErrors: Array.isArray(error) ? error : [error as string || 'An error occurred'],
                    };
                default:
                    return state;
            }
        }

        case ProductActionTypes.GET_PRODUCTS:
        case ProductActionTypes.ADD_PRODUCT:
        case ProductActionTypes.UPLOAD_IMAGE:
        case ProductActionTypes.GET_PRODUCT_DETAILS:
        case ProductActionTypes.UPDATE_PRODUCT:
        case ProductActionTypes.DELETE_PRODUCT:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case ProductActionTypes.BULK_IMPORT_PRODUCTS:
            return {
                ...state,
                importLoading: true,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };
            
        case ProductActionTypes.RESET_IMPORT_STATE:
            return {
                ...state,
                importLoading: false,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };

        default:
            return state;
    }
};

export default Products;
